import { adminMenu, instructorMenu } from "constants/menu";
import { Avatar } from "newComponents/Shared/_Atoms/Avatar/Avatar";
import Router, { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeSelectActiveLocation } from "Store/locations/selectors";
import { makeSelectCurrentUser, makeSelectUserIsLogged } from "Store/user/selectors";
import { getUserType } from "utils/users";
import LogoutButton from "newComponents/Shared/_Atoms/Buttons/LogoutButton/LogoutButton";
import CourseSelectDropdown from "newComponents/Shared/CourseSelectDropdown/CourseSelectDropdown";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import Menu from "layout/Menu/Menu";
import UserInfo from "newComponents/Shared/_Atoms/UserInfo/UserInfo";
import SideNavFooter from "./SideNavFooter";
import { setContrast } from "constants/colors";
import { handleLogout } from "Store/user/actions";

const SideNav = () => {
  const [activeLink, setActiveLink] = useState<string>("dashboard");
  const [menu, setMenu] = useState<Menu[]>();
  const [isShow, setIsShow] = useState<boolean>(false);
  const [avatar, setAvatar] = useState(true);

  const [colorScheme, setColorScheme] = useState("light");

  const dispatch = useDispatch();
  const location = useSelector(makeSelectActiveLocation);
  const currentUser = useSelector(makeSelectCurrentUser);
  const isLogged = useSelector(makeSelectUserIsLogged);
  const router = useRouter();

  const handleSideNavPosition = (): string => {
    return isShow ? "opened" : "closed";
  };

  const handleSwitchMenu = (): void => {
    setIsShow(!isShow);
  };

  const logout = () => {
    dispatch(handleLogout());
  };

  useEffect(() => {
    if (currentUser) {
      console.log('pendo initialize');
      window.pendo.initialize({
        visitor: {
          id:              currentUser.id, // Required if user is logged in
          email:        currentUser.email,// Recommended if using Pendo Feedback, or NPS Email
          // full_name:    // Recommended if using Pendo Feedback
           role:         currentUser.current_location_role// Optional
          // You can add any additional visitor level key-values here,
          // as long as it's not one of the above reserved names.
        },

        account: {
          id:              currentUser.id // Highly recommended, required if using Pendo Feedback
          // name:         // Optional
          // is_paying:    // Recommended if using Pendo Feedback
          // monthly_value:// Recommended if using Pendo Feedback
          // planLevel:    // Optional
          // planPrice:    // Optional
          // creationDate: // Optional

          // You can add any additional account level key-values here,
          // as long as it's not one of the above reserved names.
        }
      });
      setMenu(
        (currentUser && currentUser.type === "SUPER_ADMIN") ||
          (currentUser &&
            currentUser.type === "INSTRUCTOR" &&
            currentUser.current_location_role !== "INSTRUCTOR")
          ? adminMenu
          : instructorMenu
      );
    }
  }, [currentUser]);

  useEffect(() => {
    const pathLink = router.route.split("/")[1];
    if (!activeLink) {
      setActiveLink("dashboard");
    } else if (activeLink !== pathLink) {
      setActiveLink(pathLink);
    }
  }, [router]);

  useEffect(() => {
    const initialPathLink = menu?.find((link) => link.value === Router.pathname.split("/")[1]);
    if (initialPathLink) {
      setActiveLink(initialPathLink.value);
    }
    const avatarLocal = localStorage.getItem("impersonated");

    setAvatar(Boolean(avatarLocal));
  }, []);

  const handleMenuItemClick = (): void => setIsShow(false);

  const getImpersonateAvatarProps = () => {
    const init = {
      avatarURL: null,
      name: null
    };
    const avatar = localStorage.getItem("impersonated");
    const avatarName = avatar?.split("impersonate-name-")[1];

    if (avatarName) {
      init.name = avatarName.split("%20").join(" ");
    } else {
      init.avatarURL = avatar;
    }
    return init;
  };

  useEffect(() => {
    if (location?.branding?.color1) {
      setColorScheme(setContrast(location?.branding?.color1));
    }
  }, [location]);

  return (
    <>
      <aside
        style={{ backgroundColor: location?.branding?.color1 }}
        className={`layout-sidenav ${handleSideNavPosition()} ${colorScheme || ""}`}
      >
        <div>
          {currentUser && (
            <div className="avatars-container">
              <Avatar
                avatarURL={currentUser?.avatar}
                linkTarget="/account"
                isLogged={isLogged}
                showEditIcon
                name={`${currentUser?.first_name} ${currentUser?.last_name}`}
                className={avatar ? "impersonated-avatar" : ""}
              />
              {avatar && <Avatar className="impersonate-avatar" {...getImpersonateAvatarProps()} />}
            </div>
          )}
          <UserInfo
            firstName={currentUser?.first_name}
            lastName={currentUser?.last_name}
            userType={getUserType(currentUser?.type)}
          />
          <CourseSelectDropdown customClass="sidenav-course-wrapper" />
          <Menu
            menu={menu}
            onHandleMenuItemClick={handleMenuItemClick}
            activeLink={activeLink}
            brandingColor={location?.branding?.color1}
          />
          <LogoutButton handleLogout={logout} />
        </div>
        <SideNavFooter branding={location?.branding} name={location?.name} />
      </aside>
      <div className={`mobile-menu ${isShow ? "mobile-menu-transition" : ""}`}>
        <Icon icon={isShow ? "close" : "bar"} onClick={handleSwitchMenu} className="menu-icon" />
      </div>
      {isShow && <div className="sidenav-background" onClick={() => setIsShow(false)} />}
    </>
  );
};

export default SideNav;
